/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { FileUploader } from "react-drag-drop-files";
import { MultiSelect } from "react-multi-select-component";
import { useEffect } from "react";
import Utils from "../../utility/utility";
import { STRING } from "../../constants/string";
import {
  VIEW_PROJECT,
  PROJECT_CREATE,
  PROJECT_HELPER,
  DEPARTMENTSUSERS,
  PROJECT_UPDATE,
} from "../../service/apiUrl";
import { postApiCall } from "../../service/PostApiCall";
import { useParams, useNavigate } from "react-router-dom";
import LoadingButton from "../../components/LoadingButton";
import MarkdownEditor from "../../components/MarkdownEditor";

const FieldError = ({ msg }) => (
  <span className={"field-error" + (msg ? " is-shown" : "")}>{msg || ""}</span>
);

const AddProject = (props) => {
  const [errors, setErrors] = useState({});
  const [projectName, setProjectName] = useState("");
  const [department, setDepartment] = useState("");
  const [technology, setTechnology] = useState([]);
  const [tags, setTags] = useState("");
  const [developementLink, setDevelopementLink] = useState("");
  const [projectLink, setprojectLink] = useState("");
  const [estimateTime, setEstimateTime] = useState("");
  const [perHours, setPerHours] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [billingResource, setBillingResource] = useState([]);
  const [sources, setSource] = useState({});
  const [Inhouse, setInhouse] = useState(0);
  const [nda, setNda] = useState(0);
  // const [type, setType] = useState({});
  const [developerAssigned, setDeveloperAssigned] = useState([]);
  const [managersAssigned, setManagersAssigned] = useState([]);
  const [helperData, setHelperData] = useState([]);
  const [file, setFile] = useState({});
  const [fileName, setFileName] = useState([]);
  const [milestoneData, setMilestoneData] = useState([{ title: "", hours: "" }]);

  const MAX_COUNT = 5;
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [fileLimit, setFileLimit] = useState(false);

  const { projectId } = useParams();

  const navigate = useNavigate();

  const signdata = useSelector((state) => state.signinReducers);
  const user_id = signdata?.data?.id;
  const access_token = signdata?.data?.access_token;

  useEffect(() => {
    if (access_token && projectId) {
      let params = {
        id: projectId,
      };
      postApiCall(params, access_token, VIEW_PROJECT)
        .then((result) => {
          setProjectName(result?.name);
          setTags(result?.tags);
          setDevelopementLink(result?.development_link);
          setprojectLink(result?.live_link);
          setProjectDescription(result?.description);
          setPerHours(result?.per_hour);
          setEstimateTime(result?.estimated_hour);
          setCompanyName(result?.billing_company);
          setDepartment(result?.department);
          // setType(result?.billing_type);
          setSource(result?.source);
          setBillingResource(result?.billing_resource);
          setTechnology(result?.technology);
          setInhouse(result?.in_house);
          setNda(result?.under_nda);
          setDeveloperAssigned(result?.assigned_developer);
          setManagersAssigned(result?.assigned_manager);
          setMilestoneData(result?.milestone_data);
        })
        .catch((error) => {
          console.error("edit-project error", error);
        });
    }
  }, [projectId]);

  const projectobj = {
    name: projectName,
    description: projectDescription,
    department: department?.value,
    technology: technology,
    tags: tags,
    development_link: developementLink,
    in_house: Inhouse === true ? 1 : 0,
    live_link: projectLink,
    under_nda: nda == true ? 1 : 0,
    // billing_type: type?.value,
    billing_resource: billingResource,
    estimated_hour: estimateTime,
    per_hour: perHours,
    source: sources?.value,
    billing_company: companyName,
    assigned_developer: developerAssigned,
    assigned_manager: managersAssigned,
    created_by: user_id,
    info_file: file,
    milestoneData: milestoneData
  };

  const validationProject = () => {
    let message = "";
        const e = {};
    if (Utils.isEmpty(projectName)) e.projectName = STRING.PROJECTNAME;
    if (Utils.isEmpty(projectDescription)) e.projectDescription = STRING.PROJECT_DESCRIPTION;
    if (Utils.isEmpty(estimateTime)) e.estimateTime = STRING.ESTIMATE_TIME;
    if (Utils.isEmpty(perHours)) e.perHours = STRING.PER_HOURS;
    setErrors(e);
    message = Object.keys(e).length ? "invalid" : "";

    if (message) {
      return false;
    } else {
      console.log("payload :", projectobj);
      if (projectId) {
        projectobj.id = projectId;
        return postApiCall(projectobj, access_token, PROJECT_UPDATE, true).then((result) => {
          Utils.toast("success", "Project updated successfully!!!");
          navigate("/manage-project");
        });
      } else {
        return postApiCall(projectobj, access_token, PROJECT_CREATE, true).then((result) => {
          Utils.toast("success", "Project created successfully!!!");
          navigate("/manage-project");
        });
      }
    }
  };

  const fileTypes = ["txt", "pem", "ppk", "docs", "csv", "xlss", "pdf"];

  const handleChange = (inputfile) => {
    // setFile(Object.values(inputfile));
    var tempArray = [];
    for (const [key, value] of Object.entries(inputfile)) {
      tempArray.push(value?.name)
    }
    setFileName(tempArray)
  };


  //   const handleUploadFiles = files => {
  //     const uploaded = [...uploadedFiles];
  //     // let limitExceeded = false;
  //     files.some((file) => {
  //         uploaded.push(file);
  //     setUploadedFiles(uploaded);
  //     })
  //     setUploadedFiles(uploaded)

  //     //  if (!limitExceeded) 
  //  }

  // const handleFileEvent =  (e) => {
  //   const chosenFiles = Array.prototype.slice.call(e)
  //   handleUploadFiles(chosenFiles);
  // }

  useEffect(() => {
    postApiCall([], signdata?.data?.access_token, PROJECT_HELPER)
      .then((result) => {
        setHelperData(result);
      })
      .catch((error) => {
        console.error("PROJECT_HELPER", error);
      });
  }, []);

  const AddMilestoneHtml = () => {
    setMilestoneData([...milestoneData, { title: "", hours: "" }]);
  }
  return (
    <>
      <div className={props?.data?.transtion == true ? "contents" : "content"}>
        <div className="content-top-spacer"></div>
        <div className="color-body manage">
          <div className="page-head">
            <div className="page-eyebrow">Work</div>
            <h1 className="page-title">Add Project</h1>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                {/* project information block */}
                <div className="card-input mt-5 mb-2">
                  <div className="col-md-12">
                    <div className="mt-3">
                      <h5 className="border-bottom pb-2">
                        Projects Information
                      </h5>
                    </div>
                    <form>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">
                              Project Name
                            </label>
                            <input
                              type="text"
                              className={"form-control" + (errors.projectName ? " is-invalid" : "")}
                              value={projectName}
                              onChange={(name) => {
                                setProjectName(name.target.value);
                              }}
                            />
<FieldError msg={errors.projectName} />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">
                              Department
                            </label>
                            <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                              options={helperData?.departments}
                              placeholder="Please Select A Department"
                              value={department}
                              onChange={(depart) => {
                                setDepartment({
                                  label: depart?.label,
                                  value: depart?.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">
                              Technology
                            </label>
                            <MultiSelect
                              options={helperData?.technologies ?? []}
                              value={technology}
                              onChange={(technologies) => {
                                setTechnology(technologies);
                              }}
                              labelledBy="Select"
                            />

                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Tags</label>
                            <input
                              type="text"
                              className="form-control"
                              value={tags}
                              onChange={(tags) => {
                                setTags(tags.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mt-2">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">
                              Project Developements Link
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={developementLink}
                              onChange={(developements) => {
                                setDevelopementLink(developements.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mt-2">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">
                              Project Live Link
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={projectLink}
                              onChange={(projectLink) => {
                                setprojectLink(projectLink.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value="1"
                              checked={Inhouse ? true : false}
                              id="flexCheckDisabled1"
                              onChange={(house) => {
                                setInhouse(!Inhouse);
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexCheckDisabled1"
                            >
                              InHouse Project
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value="1"
                              checked={nda ? true : false}
                              id="flexCheckDisabledu"
                              onChange={(ndaa) => {
                                setNda(!nda);
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexCheckDisabledu"
                            >
                              Under NDA
                            </label>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                {/* developer assigned block */}
                <div className="card-input mt-3 mb-5">
                  <div className="col-md-12 bottom-manage">
                    <div className="mt-3">
                      <h5 className="border-bottom pb-2">
                        Resource Management
                      </h5>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label>Developer Assigned To</label>
                        <MultiSelect
                          options={helperData?.developers ?? []}
                          value={developerAssigned}
                          onChange={(developers) => {
                            setDeveloperAssigned(developers);
                          }}
                          labelledBy="Select"
                        />
                      </div>
                      <div className="col-md-6">
                        <label>Manager Assigned To</label>
                        <MultiSelect
                          options={helperData?.managers || []}
                          value={managersAssigned}
                          onChange={(managers) => {
                            setManagersAssigned(managers);
                          }}
                          labelledBy="Select"
                          hasSelectAll={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                {/* billing information block */}
                <div className="card-input mt-5">
                  <div className="col-md-12">
                    <div className="mt-3">
                      <h5 className="border-bottom pb-2">
                        Billing Information
                      </h5>
                    </div>
                    <form>
                      <div className="row">
                        <div className="col-md-6 mt-2">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">
                              Estimated Time (Hours)
                            </label>
                            <input
                              type="text"
                              className={"form-control" + (errors.estimateTime ? " is-invalid" : "")}
                              value={estimateTime}
                              onChange={(estimated) => {
                                setEstimateTime(estimated.target.value);
                              }}
                            />
<FieldError msg={errors.estimateTime} />
                          </div>
                        </div>
                        <div className="col-md-6 mt-2">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">
                              Per Hours
                            </label>
                            <input
                              type="text"
                              className={"form-control" + (errors.perHours ? " is-invalid" : "")}
                              value={perHours}
                              onChange={(hours) => {
                                setPerHours(hours.target.value);
                              }}
                            />
<FieldError msg={errors.perHours} />
                          </div>
                        </div>
                        {/* <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">
                              Type (Billing ,Offline)
                            </label>
                            <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                              options={helperData?.billing_type}
                              placeholder="Please Select Billing Type"
                              value={type}
                              onChange={(type) => {
                                setType(type);
                              }}
                            />
                          </div>
                        </div> */}
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">
                              Project Source
                            </label>
                            <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                              options={helperData?.sources}
                              value={sources}
                              placeholder="Please Select Project Source"
                              onChange={(Source) => {
                                setSource(Source);
                              }}
                            />
                          </div>
                        </div>
                        {sources?.value !== 1 ? (
                          <>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="exampleInputEmail1">
                                  Billing Company Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={companyName}
                                  onChange={(cmpname) => {
                                    setCompanyName(cmpname.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="exampleInputEmail1">
                                  Billing Resources
                                </label>
                                <MultiSelect
                                  options={helperData?.billing_sources ?? []}
                                  value={billingResource}
                                  onChange={(Resources) => {
                                    setBillingResource(Resources);
                                  }}
                                  labelledBy="Select"
                                />
                              </div>
                            </div>
                          </>
                        ) : ("")}
                      </div>
                    </form>
                  </div>
                </div>
                {/* milestone blocked */}
                <div className="row">
                  <div className="col-md-12">
                    <div className="card-input mt-3">
                      <div className="col-md-12">
                        <div className="mt-3">
                          <h5 className="border-bottom pb-2">
                            Milestone
                          </h5>
                        </div>
                        <form>
                          <div className="col-md-12">
                            {milestoneData?.length && milestoneData?.map((milestone, index) => (
                              <div className="row" key={index}>
                                <div className="col-md-7">
                                  <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">
                                      Title
                                    </label>
                                    <textarea
                                      className="form-control"
                                      value={milestone?.title}
                                      onChange={(title) => {
                                        let newArr = [...milestoneData];
                                        newArr[index].title = title.target.value;
                                        setMilestoneData(newArr);
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">
                                      Hours
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={milestone?.hours}
                                      onChange={(hours) => {
                                        let newArr = [...milestoneData];
                                        newArr[index].hours = hours.target.value;
                                        setMilestoneData(newArr);
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  <div className="form-group">
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDisabled1"
                                    >
                                      Approved
                                    </label>
                                  </div>
                                  <div className="form-group">
                                    <input
                                      className="form-input"
                                      type="checkbox"
                                      value="1"
                                      checked={milestone?.aproved ? true : false}
                                      id="flexCheckDisabled1"
                                      onChange={(aproved) => {
                                        let newArr = [...milestoneData];
                                        newArr[index].aproved = aproved.target.checked;
                                        setMilestoneData(newArr);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                            <div className="form-group">
                              <button type="button" className="create-button"
                                onClick={() => { AddMilestoneHtml() }}
                              >
                                Add Milestone
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                {/* file upload block */}
                <div className="row">
                  <div className="col-md-12">
                    <div className="card-input mt-3">
                      <div className="col-md-12">
                        <div className="mt-3">
                          <h5 className="border-bottom pb-2">
                            Information Files (.txt,.pem,.ppk)
                          </h5>
                        </div>
                        <form>
                          <div className="col-md-12">
                            <div className="">
                              <FileUploader
                                multiple={true}
                                handleChange={(e) => handleChange(e)}
                                name="file"
                                types={fileTypes}
                              />
                              {fileName?.length ? (
                                fileName.map((value, index) => {
                                  return <p key={index}>
                                    {value}
                                  </p>
                                }
                                )
                              ) : (
                                <p>
                                  {"no files uploaded yet"}
                                </p>
                              )
                              }
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* project description block: full width, grows with the text */}
            <div className="card-input mt-3 mb-5">
              <div className="col-md-12">
                <div className="mt-3">
                  <h5 className="border-bottom pb-2">
                    Project Description
                  </h5>
                </div>
                <div className="form-group">
                  {/* assigned employees read this on My Projects */}
                  <MarkdownEditor
                    value={projectDescription ?? ""}
                    onChange={setProjectDescription}
                    height="auto"
                    preview="live"
                    invalid={Boolean(errors.projectDescription)}
                  />
                  <FieldError msg={errors.projectDescription} />
                </div>
              </div>
            </div>
            {/* form submit block */}
            <div className="col-md-12">
              <div className="row mb-5">
                <div className="">
                  <LoadingButton
                    className="create-button"
                    successLabel={projectId ? "Saved" : "Created"}
                    onAction={validationProject}
                  >
                    {projectId ? 'Update' : 'Create'}
                  </LoadingButton>
                </div>
                <div className="ml-2">
                  <button type="button" className="create-button1 btn-info"

                    onClick={() => {
                      navigate("/manage-project");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProject;
